import { render } from "./konami-code.vue?vue&type=template&id=0f85eee0&lang=pug"
import script from "./konami-code.vue?vue&type=script&lang=js"
export * from "./konami-code.vue?vue&type=script&lang=js"

import "./konami-code.vue?vue&type=style&index=0&id=0f85eee0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__